export default "__VITE_ASSET__83c7dd62__"